import { API } from "@/lib/api";

async function call(path, { method = "GET", body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let payload = null;
  try {
    payload = await res.json();
  } catch {
    /* no body */
  }
  if (!res.ok) {
    const err = new Error(payload?.detail || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return payload;
}

export const projectsApi = {
  list: () => call("/projects"),
  create: ({ name, custom_instructions = "" }) =>
    call("/projects", { method: "POST", body: { name, custom_instructions } }),
  update: (id, { name, custom_instructions }) =>
    call(`/projects/${encodeURIComponent(id)}`, {
      method: "PUT",
      body: { name, custom_instructions },
    }),
  remove: (id) => call(`/projects/${encodeURIComponent(id)}`, { method: "DELETE" }),
  generateTitle: ({ user_message, assistant_message }) =>
    call("/history/title", {
      method: "POST",
      body: { user_message, assistant_message: assistant_message || "" },
    }),
};
